import type { TranslationMessages } from '../../types';

export const tabs: TranslationMessages = {
  my_profile: 'Hồ sơ của tôi',
  checkin_checkout: 'Check-in/Check-out',
  attendance: 'Điểm danh',
  schedule: 'Lịch trình',
  shift_switching: 'Đổi ca',
  shift_planning: 'Lập kế hoạch ca làm việc',
  attendance_management: 'Quản lý điểm danh',
  daily_checklist: 'Danh sách kiểm tra hàng ngày',
  point_earning: 'Kiếm điểm',
  point_store: 'Cửa hàng điểm',
  redemption: 'Đổi thưởng',
  ranking: 'Xếp hạng',
  badges: 'Huy hiệu',
  rating: 'Đánh giá',
  more: 'Thêm',
  my_profile_desc: 'Xem thông tin hồ sơ của bạn',
  checkin_checkout_desc: 'Check in và check out ca làm việc của bạn',
  attendance_desc: 'Xem hồ sơ điểm danh và bảng chấm công của bạn',
  schedule_desc: 'Xem ca làm việc được giao và giờ làm việc của bạn',
  shift_switching_desc: 'Yêu cầu và quản lý việc đổi ca của bạn',
  shift_planning_desc:
    'Lập kế hoạch ca làm việc (Chỉ dành cho Quản lý/Quản trị viên)',
  daily_checklist_desc:
    'Danh sách kiểm tra nhiệm vụ hàng ngày của bạn và theo dõi hoàn thành',
  point_earning_desc:
    'Hoàn thành nhiệm vụ để kiếm điểm và mở khóa phần thưởng',
  point_store_desc: 'Đổi điểm đã kiếm được của bạn để nhận phần thưởng',
  redemption_desc: 'Quản lý việc đổi điểm và phần thưởng của bạn',
  ranking_desc: 'Xem xếp hạng hiệu suất của bạn trong số nhân viên',
  badges_desc: 'Xem huy hiệu thành tích và phần thưởng của bạn',
  rating_desc: 'Xem đánh giá của khách hàng và quản lý về bạn',
  policies: 'Chính sách',
  policies_desc: 'Xem chính sách công ty',
  leave_requests: 'Yêu cầu nghỉ phép',
  leave_requests_desc: 'Quản lý và yêu cầu ngày nghỉ',
};
